import { Construction } from "lucide-react";

export default function Placeholder({ title, description }) {
  return (
    <div className="jr-card text-center py-16" data-testid="placeholder">
      <Construction className="w-12 h-12 text-violet-300 mx-auto mb-3" />
      <div className="text-xl font-semibold text-white mb-1">{title}</div>
      <p className="text-zinc-400 text-sm max-w-md mx-auto">{description}</p>
    </div>
  );
}
